import { render } from "./AdminHeader2.vue?vue&type=template&id=c704b370"
import script from "./AdminHeader2.vue?vue&type=script&lang=js"
export * from "./AdminHeader2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__